import { Component, DestroyRef, inject } from '@angular/core';
import { ModuleGridFooterService } from '@app/shared/components/module-grid/module-grid-footer.service';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'module-grid-footer',
    template: `
    <div>
      {{ 'MODULE.' + module.moduleName | translate }}
      <span [ngClass]="{'valid': valid, 'invalid': !valid}">({{ module.usedCount }} / {{ module.totalCount }})</span>
    </div>
  `,
    styles: [`
    div {
      font-weight: bold;
    }
  `],
    standalone: false
})
export class ModuleGridFooterComponent implements ICellRendererAngularComp {
  private readonly moduleService = inject(ModuleGridFooterService);
  public module: any; //
  public index: number; // The index of the column from which to get the module

  private destroyRef = inject(DestroyRef);

  /**
   * Get the validity of the number of selected users by module
   */
  public get valid(): boolean {
    return this.module.usedCount <= this.module.totalCount;
  }

  /**
   * Method used by Ag-grid to initialise the cell with grid parameters
   * @param params
   */
  public agInit(params: any): void {
    // Passed by pinnedRowCellRendererParams
    this.index = params.index;
    // Passed by the pinned row data
    this.module = params.data[this.index];

    // Listens to changes in selection and shows the result
    this.moduleService.footerMapSubject.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((map) => {
      this.module.usedCount = map.get(this.module.moduleName).count;
    });
  }

  /**
   * Method used by Ag-Grid to tell the grid to refresh this cell
   * This component does not include refresh logic
   * @param params
   * @returns {boolean}
   */
  public refresh(params: any): boolean {
    return false;
  }
}
